import styled from 'styled-components/macro';
import {spacing} from '@mui/system';
import {Typography as MuiTypography} from '@mui/material';

const Typography = styled(MuiTypography)(spacing);

export {Typography};
